/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";

import * as styles from "./TestStyle.module.css";

type TestDataBlockDisplayProps = Readonly<{
  dataList: {
    object?: any;
    title: string;
  }[];
}>;

export const TestCrmDataList = ({ dataList }: TestDataBlockDisplayProps) => {
  const [displayedObject, setDisplayedObject] = useState(undefined);

  return (
    <div className={styles.crmDataDisplay}>
      <h3>CRM Data</h3>
      <div className={styles.crmDataListWrapper}>
        <div className={styles.crmDataListButtons}>
          {dataList.map((data, index) => (
            <button
              key={`data-entry-button-${index}`}
              onClick={() => setDisplayedObject(data.object)}
              disabled={!data.object}
              className={styles.testButton}
            >
              {data.title}
            </button>
          ))}
        </div>
        <div className={styles.forms}>
          <div
            className={styles.container}
            dangerouslySetInnerHTML={{
              __html: `${JSON.stringify(displayedObject || { error: "ERROR" }, null, 2)
                .split("\n")
                .join("<br>")
                .split(" ")
                .join("&nbsp;")}`,
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};
